import { useEffect, useState } from 'react';

import JsonDiffReact from 'jsondiffpatch-react';

import './styles.less';

export type DiffPresenterComponentComponentProps = {
  previousPayload: any;
  currentPayload: any;
};

const DiffPresenterComponent = ({ previousPayload, currentPayload }: DiffPresenterComponentComponentProps) => {

  const [isMounted, setIsMounted] = useState<boolean>(false);
  const [diffProps, setDiffProps] = useState<any>(undefined);

  useEffect(() => {
    if (previousPayload && currentPayload) {
      setIsMounted(true);

      const diffProps = {
        left: previousPayload,
        right: currentPayload,
        show: false,
        annotated: false,
        // tips: 'test test test', // Displayed in case both elements are identical.
        objectHash: (obj: any) => obj.id || obj._id || obj.name || JSON.stringify(obj)
      };

      setDiffProps(diffProps);
    }
  }, [previousPayload, currentPayload])

  return <>
    {isMounted
      ? <div style={{ maxHeight: '600px', overflow: 'auto' }}>
        <JsonDiffReact {...diffProps} />
      </div>
      : null}
  </>;
};

export default DiffPresenterComponent;
